import { DEFAULT_APPROVAL_FIELD_APPROVE_REJECT } from "components/Event/FormsV2/constants";
import { get } from "lodash";

export default function isRowPendingV2(r) {
  return !["approved", "rejected"].includes(
    get(r, `${DEFAULT_APPROVAL_FIELD_APPROVE_REJECT.id}.value`)
  );
}
